import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AuthLayout, AuthField, AuthError, SubmitButton, Notice, useSubmitState } from "@/components/auth/AuthParts";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sentMessage, setSentMessage] = useState("");
  const { error, loading, submit } = useSubmitState(async () => {
    const { data } = await api.post("/auth/forgot-password", { email });
    setSentMessage(data.message);
  });

  const footer = <>Remembered it? <Link to="/login" data-testid="forgot-back-to-login" className="link-blue">Log in →</Link></>;

  return (
    <AuthLayout title="Forgot Password" testId="forgot-password-page" footer={footer}>
      <div className="mt-6 border-2 border-black p-6 space-y-4 bg-white hard-shadow">
        {sentMessage ? (
          <>
            <Notice testId="forgot-success" title="Check your email">
              {sentMessage} The link works for 1 hour. Not there? Check your spam folder.
            </Notice>
            <button data-testid="forgot-try-again" type="button" onClick={() => setSentMessage("")} className="font-mono-data text-xs uppercase link-blue">
              Use a different email
            </button>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="font-mono-data text-xs uppercase text-gray-700">
              Enter the email you signed up with and we'll send you a link to choose a new password.
            </p>
            <AuthField label="Email" testId="forgot-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <AuthError testId="forgot-error" message={error} />
            <SubmitButton testId="forgot-submit" loading={loading}>Send Reset Link</SubmitButton>
          </form>
        )}
      </div>
    </AuthLayout>
  );
}
